import React from 'react'

import Header from './components/organisms/header/Header'
import Sidebar from './components/organisms/sidebar/Sidebar'

const Layout: React.FC<{}> = (props) => {
  return (
    <div>
      <Header />
      <div style={{ display: 'flex' }}>
        <Sidebar />
        <div style={{ flex: 1 }}>
          {props.children}
        </div>
      </div>
    </div>
  )
}

export default Layout
